export * from './sidebar.directive';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/directives/sidebar/index.ts